// src/utils/exportToExcel.js
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

/**
 * data: array of plain objects
 * fileName: "OrderHead_2025-11-28"
 * sheetName: "OrderHead"
 */
export function exportToExcel({ data, fileName, sheetName }) {
  if (!data || data.length === 0) {
    alert("No data to export");
    return;
  }

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(data);

  XLSX.utils.book_append_sheet(wb, ws, sheetName || "Sheet1");

  const excelBuffer = XLSX.write(wb, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([excelBuffer], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  });

  saveAs(blob, `${fileName || "report"}.xlsx`);
}
